import { NavigationConfig } from "./navigationConfig.types";

export const navigationConfig: NavigationConfig = [
  // ─── HOME (always visible, direct route) ─── //
  {
    id: "home",
    label: "Home",
    icon: "home",
    route: { type: "internal", path: "/" },
    alwaysVisible: true,
  },

  // ─── OPERATIONS ─── //
  {
    id: "operations",
    label: "Operations",
    icon: "operations",
    children: [
      {
        id: "operations-cat",
        label: "Clinical Automation Tool",
        abilityKey: "operations.clinicalautomationtool",
        route: { type: "envKey", envKey: "cat" },
      },
      {
        id: "operations-external-pbm",
        label: "External PBM",
        abilityKey: "operations.extpbm",
        route: { type: "envKey", envKey: "perks" },
      },
      {
        id: "operations-rejected-claim-review",
        label: "Rejected Claim Review",
        abilityKey: "operations.Claims",
        route: { type: "envKey", envKey: "rxview" },
      },
    ],
  },

  // ─── ELIGIBILITY & CLAIMS ─── //
  {
    id: "eligibility",
    label: "Eligibility & Claims",
    icon: "eligibility",
    children: [
      {
        id: "eligibility-nextgen-eligibility",
        label: "NextGen Eligibility",
        abilityKey: "eligibility",
        route: { type: "envKey", envKey: "eligibility" },
      },
      {
        id: "eligibility-member-search",
        label: "Member Search",
        abilityKey: "rxlite.member",
        route: { type: "component", component: "member" },
      },
      {
        id: "eligibility-claims-search",
        label: "Claims Search",
        abilityKey: "rxlite.claims",
        route: { type: "component", component: "claims" },
      },
    ],
  },

  // ─── MANUAL CLAIM ─── //
  {
    id: "manual-claim",
    label: "Manual Claim",
    icon: "manualclaim",
    children: [
      {
        id: "manual-claim-member-reimbursement",
        label: "Member Reimbursement",
        route: {
          type: "envKey",
          envKey: "miscFrontendGenAI",
          envPath: "/manual-claim/member-reimbursement",
        },
      },
    ],
  },

  // ─── PRODUCT ─── //
  {
    id: "product",
    label: "Product",
    icon: "product",
    abilityKey: "product",
    children: [
      {
        id: "product-masters",
        label: "Masters",
        children: [
          {
            id: "product-master",
            label: "Product Master",
            route: {
              type: "envKey",
              envKey: "productFrontendGenAI",
              envPath: "/masters/product-master",
            },
          },
          {
            id: "product-gpi-master",
            label: "GPI Master",
            route: {
              type: "envKey",
              envKey: "productFrontendGenAI",
              envPath: "/masters/gpi-master",
            },
          },
        ],
      },
    ],
  },
  // ─── PLAN ─── //
  {
    id: "plan",
    label: "Plan",
    icon: "plan",
    abilityKey: "plan",
    children: [
      {
        id: "plan-by-plan-code",
        label: "Plan by Plan Code",
        abilityKey: "planedit",
        route: {
          type: "envKey",
          envKey: "planEditFrontendGenAI",
          envPath: "/plan-by-plan-code",
        },
      },
      {
        id: "plan-product-list",
        label: "Product List",
        children: [
          {
            id: "plan-gpi-list",
            label: "Plan GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/plan-gpi-list",
            },
          },
          {
            id: "plan-ndc-list",
            label: "Plan NDC List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/plan-ndc-list",
            },
          },
          {
            id: "preferred-gpi-list",
            label: "Preferred GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/preferred-gpi-list",
            },
          },
          {
            id: "preferred-ndc-list",
            label: "Preferred NDC List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/preferred-ndc-list",
            },
          },
          {
            id: "pharmacy-network-gpi-list",
            label: "Pharmacy Network GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/pharmacy-network-gpi-list",
            },
          },
          {
            id: "pharmacy-network-ndc-list",
            label: "Pharmacy Network NDC List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/pharmacy-network-ndc-list",
            },
          },
          {
            id: "multi-ingredient-compound-gpi-list",
            label: "Multi-Ingredient Compound GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/multi-ingredient-compound-gpi-list",
            },
          },
          {
            id: "multi-ingredient-compound-ndc-list",
            label: "Multi-Ingredient Compound NDC List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/multi-ingredient-compound-ndc-list",
            },
          },
          {
            id: "list-qualifier",
            label: "List Qualifier",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/list-qualifier",
            },
          },
          {
            id: "plan-gpi-super-list",
            label: "Plan GPI Super List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/plan-gpi-super-list",
            },
          },
          {
            id: "plan-ndc-super-list",
            label: "Plan NDC Super List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/plan-ndc-super-list",
            },
          },
          {
            id: "pharmacy-network-gpi-super-list",
            label: "Pharmacy Network GPI Super List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/pharmacy-network-gpi-super-list",
            },
          },
          {
            id: "pharmacy-network-ndc-super-list",
            label: "Pharmacy Network NDC Super List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/pharmacy-network-ndc-super-list",
            },
          },
          {
            id: "product-qualifier-exclusion-list",
            label: "Product Qualifier Exclusion List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/product-qualifier-exclusion-list",
            },
          },
        ],
      },
      {
        id: "plan-formulary-clinical",
        label: "Formulary & Clinical NDC/GPI List",
        children: [
          {
            id: "premium-exclusion-plan-ndc-gpi-list",
            label: "Premium Exclusion Plan NDC/GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/premium-exclusion-plan-ndc-gpi-list",
            },
          },
          {
            id: "premium-value-formulary-ndc-gpi-list",
            label: "Premium Value Formulary NDC/GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/premium-value-formulary-ndc-gpi-list",
            },
          },
          {
            id: "mspn-list",
            label: "MSPN (MedicalRx Specialty Provider Network) List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/mspn-list",
            },
          },
          {
            id: "mbo-list",
            label: "MBO (MedicalRx Benefit Optimization) List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/mbo-list",
            },
          },
          {
            id: "esbo-list",
            label: "ESBO (Enhanced Specialty Benefit Optimization) List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/esbo-list",
            },
          },
          {
            id: "csbo-list",
            label: "CSBO (Core Specialty Benefit Optimization) List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/product-list/csbo-list",
            },
          },
        ],
      },
      {
        id: "plan-dynamic-prior-authorization",
        label: "Dynamic Prior Authorization",
        children: [
          {
            id: "dynamic-prior-authorization",
            label: "Dynamic Prior Authorization",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/dynamic-prior-authorization/dynamic-prior-authorization",
            },
          },
          {
            id: "dynamic-prior-authorization-list",
            label: "Dynamic Prior Authorization List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/dynamic-prior-authorization/dynamic-prior-authorization-list",
            },
          },
          {
            id: "dynamic-prior-authorization-profile",
            label: "Dynamic Prior Authorization Profile",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/dynamic-prior-authorization/dynamic-prior-authorization-profile",
            },
          },
          {
            id: "plan-calendar",
            label: "Plan Calendar",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/dynamic-prior-authorization/plan-calendar",
            },
          },
          {
            id: "plan-holiday-calendar",
            label: "Plan Holiday Calendar",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/dynamic-prior-authorization/plan-holiday-calendar",
            },
          },
          {
            id: "dynamic-pa-adapter-kit-profile",
            label: "Dynamic PA Adapter Kit Profile",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/dynamic-prior-authorization/dynamic-pa-adapter-kit-profile",
            },
          },
        ],
      },
      {
        id: "plan-prior-authorization",
        label: "Prior Authorization",
        children: [
          {
            id: "prior-authorization-reason-code",
            label: "Prior Authorization Reason Code",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/prior-authorization-reason-code",
            },
          },
          {
            id: "prior-authorization-gpi-list",
            label: "Prior Authorization GPI List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/prior-authorization-gpi-list",
            },
          },
          {
            id: "prior-authorization-ndc-list",
            label: "Prior Authorization NDC List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/prior-authorization-ndc-list",
            },
          },
          {
            id: "prior-authorization-agent-code",
            label: "Prior Authorization Agent Code",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/prior-authorization-agent-code",
            },
          },
          {
            id: "pa-reason-code-list",
            label: "PA Reason Code List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/pa-reason-code-list",
            },
          },
          {
            id: "carrier-pa-drug-status-restrictions",
            label: "Carrier PA Drug Status Restrictions",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/carrier-pa-drug-status-restrictions",
            },
          },
          {
            id: "regional-disaster-override-table",
            label: "Regional Disaster Override Table",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/regional-disaster-override-table",
            },
          },
          {
            id: "pa-agent-code-list",
            label: "PA Agent Code List",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/pa-agent-code-list",
            },
          },
        ],
      },
      {
        id: "plan-multiple-pa-processing",
        label: "Multiple PA Processing",
        children: [
          {
            id: "drug-status-priority-schedule",
            label: "Drug Status Priority Schedule",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/drug-status-priority-schedule",
            },
          },
          {
            id: "pa-hierarchy-rule-schedule",
            label: "PA Hierarchy Rule Schedule",
            route: {
              type: "envKey",
              envKey: "planFrontendGenAI",
              envPath: "/prior-authorization/pa-hierarchy-rule-schedule",
            },
          },
        ],
      },
    ],
  },

  // ─── PRICE ─── //
  {
    id: "pricing",
    label: "Price",
    icon: "pricing",
    abilityKey: "pricing",
    children: [
      {
        id: "pricing-price-schedule",
        label: "Price Schedule",
        children: [
          {
            id: "pricing-schedule",
            label: "Price Schedule",
            abilityKey: "pricing.priceschedule",
            route: { type: "program", program: "RCPRC003" },
          },
          {
            id: "pricing-table",
            label: "Price Table",
            abilityKey: "pricing.pricetable",
            route: { type: "program", program: "RCPTF031" },
          },
          {
            id: "pricing-drug-cost-schedule",
            label: "Drug Cost Schedule",
            abilityKey: "pricing.drugcostschedule",
            route: { type: "program", program: "RCDC3001" },
          },
          {
            id: "pricing-drug-cost-comparison-schedule",
            label: "Drug Cost Comparison Schedule",
            abilityKey: "pricing.drugcostcomparisonschedule",
            route: { type: "program", program: "RCDC5001" },
          },
        ],
      },
      {
        id: "pricing-price-basis-schedule",
        label: "Price Basis Schedule",
        abilityKey: "pricing.priceBasisSchedule",
        route: { type: "program", program: "RCPS7001" },
      },
      {
        id: "pricing-fee-schedules",
        label: "Fee Schedules",
        abilityKey: "pricing",
        children: [
          {
            id: "pricing-administrative-fee-profile",
            label: "Administrative Fee Profile",
            abilityKey: "pricing.administrativefeeprofile",
            route: { type: "program", program: "RCAFR001" },
          },
          {
            id: "pricing-administrative-fee-schedule",
            label: "Administrative Fee Schedule",
            abilityKey: "pricing.administrativefeeschedule",
            route: { type: "program", program: "RCAFS001" },
          },
          {
            id: "pricing-fee-schedule",
            label: "Fee Schedule",
            abilityKey: "pricing.feeschedule",
            route: { type: "program", program: "RCFSH001" },
          },
          {
            id: "pricing-professional-service-fee-schedule",
            label: "Professional Service Fee Schedule",
            abilityKey: "pricing.professionalservicefeeschedule",
            route: { type: "program", program: "RCSFH001" },
          },
          {
            id: "pricing-professional-service-fee-table",
            label: "Professional Service Fee Table",
            abilityKey: "pricing.professionalservicefeetable",
            route: { type: "program", program: "RCSFT001" },
          },
          {
            id: "pricing-state-fee-schedule",
            label: "State Fee Schedule",
            abilityKey: "pricing.statefeeschedule",
            route: { type: "program", program: "RCSFS001" },
          },
        ],
      },
      {
        id: "pricing-lists-and-tables",
        label: "Lists and Tables",
        abilityKey: "pricing",
        children: [
          {
            id: "pricing-cost-source-type-list",
            label: "Cost Source/Type List",
            abilityKey: "pricing.costsourcetypelist",
            route: { type: "program", program: "RCSCH001" },
          },
          {
            id: "pricing-pos-rebate-list",
            label: "POS Rebate List",
            abilityKey: "pricing.posrebatelist",
            route: { type: "program", program: "RCRBL001" },
          },
          {
            id: "pricing-retail-mail-table",
            label: "Retail & Mail Table",
            abilityKey: "pricing.retailmailtable",
            route: { type: "program", program: "RCRMT001" },
          },
          {
            id: "pricing-state-pricing-table",
            label: "State Pricing Table",
            abilityKey: "pricing.statepricingtable",
            route: { type: "program", program: "RCSPT001" },
          },
          {
            id: "pricing-tax-rate-code",
            label: "Tax Rate Codes",
            abilityKey: "pricing.taxratecodes",
            route: { type: "program", program: "RCTRC001" },
          },
        ],
      },
      {
        id: "pricing-mac-list",
        label: "MAC List",
        abilityKey: "pricing",
        children: [
          {
            id: "pricing-mac-list-main",
            label: "MAC List",
            abilityKey: "pricing.maclist",
            route: { type: "program", program: "RCMCL001" },
          },
          {
            id: "pricing-mac-list-schedule",
            label: "MAC List Schedule",
            abilityKey: "pricing.maclistschedule",
            route: { type: "program", program: "RCMLS001" },
          },
          {
            id: "pricing-mac-list-identifier",
            label: "MAC List Identifier",
            abilityKey: "pricing.maclistidentifier",
            route: { type: "program", program: "RCMLI001" },
          },
        ],
      },
      {
        id: "pricing-miscellaneous-schedules",
        label: "Miscellaneous Schedules",
        abilityKey: "pricing",
        children: [
          {
            id: "pricing-amount-due-schedule",
            label: "Amount Due Schedule",
            abilityKey: "pricing.amountdueschedule",
            route: { type: "program", program: "RCADS001" },
          },
          {
            id: "pricing-pharmacy-network-tax-schedule",
            label: "Pharmacy Network Tax Schedule",
            abilityKey: "pricing.pharmacynetworktaxschedule",
            route: { type: "program", program: "RCTXP001" },
          },
          {
            id: "pricing-rate-percent-override-schedule",
            label: "Rate Percent Override Schedule",
            abilityKey: "pricing.ratepercentoverrideschedule",
            route: { type: "program", program: "RCNRB001" },
          },
          {
            id: "pricing-rx-restriction-schedule",
            label: "Rx Restriction Schedule",
            abilityKey: "pricing.rxrestrictionschedule",
            route: { type: "program", program: "RCRRD001" },
          },
          {
            id: "pricing-rx-price-schedule",
            label: "RxPrice Schedule",
            abilityKey: "pricing.rxpriceschedule",
            route: { type: "program", program: "RCRP1001" },
          },
          {
            id: "pricing-tax-schedule",
            label: "Tax Schedule",
            abilityKey: "pricing.taxschedule",
            route: { type: "program", program: "RCTAX001" },
          },
          {
            id: "pricing-withhold-schedule",
            label: "Withhold Schedule",
            abilityKey: "pricing.withholdschedule",
            route: { type: "program", program: "RCWSH001" },
          },
        ],
      },
      {
        id: "pricing-real-time-pos-rebate-table",
        label: "Real Time POS Rebate Table",
        abilityKey: "pricing.realtimeposrebatetable",
        route: { type: "program", program: "RCDXR001" },
      },
      {
        id: "pricing-real-time-pricing",
        label: "Real-Time Pricing",
        abilityKey: "pricing.realtimepricetable",
        children: [
          {
            id: "pricing-real-time-pricing-profile",
            label: "Real-Time Pricing Profile",
            abilityKey: "pricing.realtimepricingprofile",
            route: { type: "program", program: "RCRT1001I" },
          },
          {
            id: "pricing-real-time-pricing-product",
            label: "Real-Time Pricing Product",
            abilityKey: "pricing.realtimepricingproduct",
            route: { type: "envKey", envKey: "priceFrontendGenAIV2", envPath: "/price/real-time-pricing-product" },
          },
        ],
      },
      {
        id: "pricing-shipping-fee",
        label: "Shipping Fee",
        children: [
          {
            id: "pricing-shipping-fee-schedule",
            label: "Shipping Fee Schedule",
            route: {
              type: "envKey",
              envKey: "priceFrontendGenAIV2",
              envPath: "/price/shipping-fee-schedule",
            },
          },
          {
            id: "pricing-shipping-fee-enrollment-profile",
            label: "Shipping Fee Enrollment Profile",
            route: {
              type: "envKey",
              envKey: "priceFrontendGenAIV2",
              envPath: "/price/shipping-fee-enrollment-profile",
            },
          },
        ],
      },
    ],
  },

  // ─── PATIENT PAY ─── //
  {
    id: "patient-pay",
    label: "Patient Pay",
    icon: "patientpay",
    abilityKey: "patientpay",
    children: [
      {
        id: "patient-pay-schedules",
        label: "Patient Pay Schedule",
        children: [
          {
            id: "patient-pay-schedule-main",
            label: "Patient Pay Schedule",
            route: {
              type: "envKey",
              envKey: "patientPayFrontendGenAI",
              envPath: "/patient-pay-schedule",
            },
          },
          {
            id: "patient-pay-table",
            label: "Patient Pay Table",
            route: {
              type: "envKey",
              envKey: "patientPayFrontendGenAI",
              envPath: "/patient-pay-table",
            },
          },
          {
            id: "patient-pay-copay-schedule",
            label: "Copay Schedule",
            route: {
              type: "envKey",
              envKey: "patientPayFrontendGenAI",
              envPath: "/copay-schedule",
            },
          },
          {
            id: "patient-pay-additional-schedule",
            label: "Additional Patient Pay Schedule",
            route: {
              type: "envKey",
              envKey: "patientPayFrontendGenAI",
              envPath: "/additional-patient-pay-schedule",
            },
          },
        ],
      },
      {
        id: "patient-pay-coupon-gpi-list",
        label: "Coupon Patient Pay GPI List",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAI",
          envPath: "/coupon-patient-pay-gpi-list",
        },
      },
      {
        id: "patient-pay-coupon-ndc-list",
        label: "Coupon Patient Pay NDC List",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAIV2",
          envPath: "/coupon-patient-pay-ndc-list",
        },
      },
      {
        id: "patient-pay-discount-table",
        label: "Discount Patient Pay Table",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAI",
          envPath: "/discount-patient-pay-table",
        },
      },
      {
        id: "patient-pay-max-copay-schedule",
        label: "Max Copay Schedule",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAI",
          envPath: "/max-copay-schedule",
        },
      },
      {
        id: "patient-pay-on-benefit-mpbm-provider-list",
        label: "On-Benefit mPBM Provider List",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAIV2",
          envPath: "/on-benefit-mpbm-provider-list",
        },
      },
      {
        id: "patient-pay-price-edge-schedule",
        label: "Price Edge Schedule",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAI",
          envPath: "/price-edge-schedule",
        },
      },
      {
        id: "patient-pay-processor-fee-table",
        label: "Processor Fee Table",
        route: {
          type: "envKey",
          envKey: "patientPayFrontendGenAI",
          envPath: "/processor-fee-table",
        },
      },
    ],
  },

  // ─── ACCUMULATORS ─── //
  {
    id: "accumulators",
    label: "Accumulators",
    icon: "accumulators",
    abilityKey: "accumulator",
    children: [
      {
        id: "accumulators-benefit-schedules",
        label: "Benefit Schedules",
        children: [
          {
            id: "accumulators-deductible-schedule",
            label: "Deductible Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/deductible-schedule",
            },
          },
          {
            id: "accumulators-out-of-pocket-schedule",
            label: "Out of Pocket Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/out-of-pocket-schedule",
            },
          },
          {
            id: "accumulators-benefit-max-schedule",
            label: "Benefit Max Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/benefit-max-schedule",
            },
          },
          {
            id: "accumulators-benefit-max-drug-status-schedule",
            label: "Benefit Max Drug Status Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/benefit-max-drug-status-schedule",
            },
          },
        ],
      },
      {
        id: "accumulators-medicare-partd-schedules",
        label: "Medicare Part D Schedules",
        children: [
          {
            id: "accumulators-troop-schedule",
            label: "TrOOP Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/troop-schedule",
            },
          },
          {
            id: "accumulators-lics-schedule",
            label: "LICS Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/lics-schedule",
            },
          },
          {
            id: "accumulators-standard-troop-schedule",
            label: "Standard TrOOP Schedule",
            route: {
              type: "envKey",
              envKey: "accumsFrontendGenAI",
              envPath: "/standard-troop-schedule",
            },
          },
        ],
      },
      {
        id: "accumulators-accumulation-code",
        label: "Accumulation Codes",
        route: {
          type: "envKey",
          envKey: "accumsFrontendGenAI",
          envPath: "/accumulation-code",
        },
      },
      {
        id: "accumulators-accumulation-code-list",
        label: "Accumulation Code List",
        route: {
          type: "envKey",
          envKey: "accumsFrontendGenAI",
          envPath: "/accumulation-code-list",
        },
      },
      {
        id: "accumulators-override-schedule",
        label: "Accumulator Override Schedule",
        route: {
          type: "envKey",
          envKey: "accumsFrontendGenAI",
          envPath: "/accumulator-overrride-schedule",
        },
      },
      {
        id: "accumulators-adjustment-reason-code",
        label: "Adjustment Reason Codes",
        route: {
          type: "envKey",
          envKey: "accumsFrontendGenAI",
          envPath: "/adjustment-reason-code",
        },
      },
      {
        id: "accumulators-adjustment-reason-code-list",
        label: "Adjustment Reason Code List",
        route: {
          type: "envKey",
          envKey: "accumsFrontendGenAI",
          envPath: "/adjustment-reason-code-list",
        },
      },
    ],
  },

  // ─── SAVINGS ACCOUNTS ─── //
  {
    id: "savings-accounts",
    label: "Savings Accounts",
    icon: "savingsaccounts",
    abilityKey: "price.savingsaccount",
    children: [
      {
        id: "savings-account-schedule",
        label: "Savings Account Schedule",
        abilityKey: "price.savingsaccount.savingsaccountschedule",
        route: {
          type: "envKey",
          envKey: "priceFrontendGenAI",
          envPath: "/savings-account/savings-account-schedule",
        },
      },
      {
        id: "savings-account-bank-request-method",
        label: "Savings Account Bank Request Method",
        abilityKey: "price.savingsaccount.savingsaccountbankrequestmethod",
        route: {
          type: "envKey",
          envKey: "priceFrontendGenAI",
          envPath: "/savings-account/savings-account-bank-request-method",
        },
      },
      {
        id: "savings-account-subtype",
        label: "Savings Account Subtype",
        abilityKey: "price.savingsaccount.savingsaccountsubtype",
        route: {
          type: "envKey",
          envKey: "priceFrontendGenAI",
          envPath: "/savings-account/savings-account-subtype",
        },
      }
    ],
  },

  // ─── DUR ─── //
  {
    id: "dur",
    label: "DUR",
    icon: "dur",
    abilityKey: "durmenu",
    children: [
      {
        id: "dur-table",
        label: "DUR Table",
        abilityKey: "durtable",
        route: { type: "envKey", envKey: "durFrontendGenAI", envPath: "/DUR-Tables" },
      },
      {
        id: "dur-cdsafety-user-overrides",
        label: "CDSAFETY User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-cdsafety-gpi-override",
            label: "CDSAFETY GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/CDSAFETY-GPIOverrideList",
            },
          },
          {
            id: "dur-cdsafety-super-gpi-override",
            label: "CDSAFETY Super GPI O/R List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/CDSAFETY-SuperGPIO-RList",
            },
          },
        ],
      },
      {
        id: "dur-diagcaut-user-overrides",
        label: "DIAGCAUT User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-diagcaut-gpi-override",
            label: "DIAGCAUT GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DIAGCAUT-GPIOverrideList",
            },
          },
          {
            id: "dur-diagcaut-super-gpi-override",
            label: "DIAGCAUT Super GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DIAGCAUT-SuperGPIO-RList",
            },
          },
        ],
      },
      {
        id: "dur-ddi-dtms-user-overrides",
        label: "DDI-DTMS User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-ddi-dtms-gpi-override",
            label: "DDI-DTMS GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DDI-DTMS-GPIOverrideList",
            },
          },
       ],
      },
      {
        id: "dur-dinferrd-user-overrides",
        label: "DINFERRD User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-contraindications-override-lists",
            label: "GPI Contraindications Override Lists",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/GPI-ContraindicationsOverrideLists",
            },
          },
        ],
      },
      {
        id: "dur-dosecheck-user-overrides",
        label: "DOSECHECK User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-dosecheck-gpi-override",
            label: "DOSECHECK GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DOSECHEK-GPIOverrideList",
            },
          },
        ],
      },
      {
        id: "dur-drug-age-user-overrides",
        label: "DRUG-AGE User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-drug-age-gpi-override",
            label: "DRUG-AGE GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DRUG_AGE-GPIOverrideList",
            },
          },
        ],
      },
      {
        id: "dur-duplimit-user-overrides",
        label: "DUPLIMIT User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-duplimit-subgroup",
            label: "DUPLIMIT Subgroup",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUPLIMIT-subgroup",
            },
          },
          {
            id: "dur-duplimit-superlist",
            label: "DUPLIMIT Super List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUPLIMIT-SuperList",
            },
          },
        ],
      },
      {
        id: "dur-duprx-user-overrides",
        label: "DUPRX User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-duprx-gpi-override",
            label: "DUPRX GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUPRX-GPIOverrideList",
            },
          },
          {
            id: "dur-duprx-state-list-dea-override",
            label: "State List by DEA Class Override",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/StateList-DEAClassOverride",
            },
          },
        ],
      },
      {
        id: "dur-dupther-user-overrides",
        label: "DUPTHER User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-dupther-gpi-override",
            label: "DUPTHER GPI Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUPTHER-GPIOverrideList",
            },
          },
          {
            id: "dur-dupther-super-gpi-override",
            label: "DUPTHER Super GPI O/R List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUPTHER-SuperGPIO-RList",
            },
          },
        ],
      },
      {
        id: "dur-medlimit-user-overrides",
        label: "MEDLIMIT User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-medlimit-conversion",
            label: "MEDLIMIT Conversion Table",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUR-MEDLIMITConversionTable",
            },
          },
          {
            id: "dur-medlimit-gpi-list",
            label: "MEDLIMIT GPI List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/MEDLIMIT-GPIList",
            },
          },
        ],
      },
      {
        id: "dur-overlap-user-overrides",
        label: "OVERLAP User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-overlap-subgroup-list",
            label: "OVERLAP Subgroup List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/Overlap-SubgroupList",
            },
          },
          {
            id: "dur-overlap-subgroup-table",
            label: "OVERLAP Subgroup Table",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/Overlap-SubgroupTable",
            },
          },
        ],
      },
      {
        id: "dur-thercont-lists",
        label: "THERCONT Lists",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-thercont-gpi-list",
            label: "THERCONT GPI List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAIV2",
              envPath: "/thercont-gpi-list",
            },
          },
          {
            id: "dur-thercont-ingredient-list",
            label: "THERCONT Ingredient List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAIV2",
              envPath: "/thercont-ingredient-list",
            },
          },
        ],
      },
      {
        id: "dur-therdose-user-overrides",
        label: "THERDOSE User Overrides",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-therdose-ingredient-table",
            label: "DUR Ingredient Table",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUR-IngredientTable",
            },
          },
          {
            id: "dur-therdose-ingredient-list",
            label: "Ingredient List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/Ingredient-List",
            },
          },
          {
            id: "dur-therdose-medlimit-gpi-list",
            label: "MEDLIMIT GPI List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/MEDLIMIT-GPIList",
            },
          },
        ],
      },
      {
        id: "dur-pps-service-overrides",
        label: "DUR/PPS",
        abilityKey: "durtable",
        children: [
          {
            id: "dur-pps-conflict-code-list",
            label: "DUR Conflict Code List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/dur-conflict-code-list",
            },
          },
          {
            id: "dur-pps-service-type-list",
            label: "DUR Service Type List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/dur-service-type-list",
            },
          },
          {
            id: "dur-pps-program",
            label: "DUR/PPS Program",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUR-PPSProgram",
            },
          },
          {
            id: "dur-pps-service-tables",
            label: "DUR/PPS Service Tables",
            abilityKey: "durppsfee.selectdurppsservicestable",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/DUR-PPSServicesTables",
            },
          },
          {
            id: "dur-pps-drug-status-override",
            label: "PPS Drug Status Override List",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/pps-drug-status-ovr-list",
            },
          },
          {
            id: "dur-pps-service-level-dur-pps-overrides",
            label: "Service Level DUR/PPS Overrides",
            abilityKey: "durtable",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/duplimit-dur-pps-service-override",
            },
          },
          {
            id: "dur-pps-submitted-dur-pps-service-override",
            label: "Submitted DUR/PPS Service Override",
            abilityKey: "durtable",
            route: {
              type: "envKey",
              envKey: "durFrontendGenAI",
              envPath: "/submitted-durpps-service-override",
            },
          },
        ],
      },
    ],
  },

  // ─── PROVIDER ─── //
  {
    id: "provider",
    label: "Provider",
    icon: "provider",
    children: [
      {
        id: "provider-care-facility-network",
        label: "Care Facility/Network",
        abilityKey: "provider.carefacilitynetwork",
        children: [
          {
            id: "provider-care-network",
            label: "Care Network",
            route: {
              type: "envKey",
              envKey: "careFacilityNetworkFrontendGenAI",
              envPath: "/care-network-display",
            },
          },
          {
            id: "provider-care-facility",
            label: "Care Facility",
            route: {
              type: "envKey",
              envKey: "careFacilityNetworkFrontendGenAI",
              envPath: "/care-facility",
            },
          },
          {
            id: "provider-care-qualifier",
            label: "Care Qualifier",
            route: {
              type: "envKey",
              envKey: "careFacilityNetworkFrontendGenAI",
              envPath: "/care-qualifier",
            },
          },
          {
            id: "provider-care-facility-list",
            label: "Care Facility List",
            route: {
              type: "envKey",
              envKey: "careFacilityNetworkFrontendGenAI",
              envPath: "/care-facility-list",
            },
          },
        ]
      },
      {
        id: "provider-pharmacy",
        label: "Pharmacy",
        abilityKey: "provider.pharmacy",
        children: [
          {
            id: "provider-pharmacy-main",
            label: "Pharmacy",
            route: { type: "envKey", envKey: "pharmacyFrontendGenAI", envPath: "/pharmacy" },
          },
          {
            id: "provider-pharmacy-relationship",
            label: "Relationship",
            route: {
              type: "envKey",
              envKey: "pharmacyFrontendGenAI",
              envPath: "/relationship",
            },
          },
          {
            id: "provider-pharmacy-contract",
            label: "Contract",
            route: { type: "envKey", envKey: "pharmacyFrontendGenAI", envPath: "/contract" },
          },
          {
            id: "provider-pharmacy-region",
            label: "Region",
            route: { type: "envKey", envKey: "pharmacyFrontendGenAI", envPath: "/region" },
          },
          {
            id: "provider-pharmacy-county-code",
            label: "County Code",
            route: {
              type: "envKey",
              envKey: "pharmacyFrontendGenAI",
              envPath: "/country-code",
            },
          },
          {
            id: "provider-pharmacy-parent-organization",
            label: "Parent Organization",
            route: {
              type: "envKey",
              envKey: "pharmacyFrontendGenAI",
              envPath: "/parent-organization",
            },
          },
          {
            id: "provider-pharmacy-pharmacist",
            label: "Pharmacist",
            route: {
              type: "envKey",
              envKey: "pharmacyFrontendGenAI",
              envPath: "/pharmacist",
            },
          },
          {
            id: "provider-pharmacy-cross-reference",
            label: "Pharmacy Cross-Reference",
            route: {
              type: "envKey",
              envKey: "pharmacyFrontendGenAI",
              envPath: "/pharmacy-cross-reference",
            },
          },
          {
            id: "provider-pharmacy-remit",
            label: "Remit and Reconciliation",
            route: {
              type: "envKey",
              envKey: "pharmacyFrontendGenAI",
              envPath: "/remit-and-reconcilation",
            },
          },
        ]
      },
      {
        id: "provider-pharmacy-network",
        label: "Pharmacy Network",
        abilityKey: "provider.pharmacynetwork",
        children: [
          {
            id: "provider-pharmacy-network-search",
            label: "Pharmacy Network Search",
            route: { type: "program", program: "RCPHN002" },
          },
          {
            id: "provider-pharmacy-network-super-network",
            label: "Super Network Search",
            route: { type: "program", program: "RCSNH002" },
          },
          {
            id: "provider-pharmacy-network-overrides",
            label: "Pharmacy Network List with Overrides",
            route: {
              type: "envKey",
              envKey: "pharmacyNetworkFrontendGenAI",
              envPath: "/pharmacy-network-list-with-overrides",
            },
          },
        ],
      },
      {
        id: "provider-pharmacy-sanctions",
        label: "Pharmacy Sanctions Master",
        route: {
          type: "envKey",
          envKey: "pharmacyFrontendGenAI",
          envPath: "/pharmacy-sanctions-master",
        },
      },
      {
        id: "provider-pharmacy-taxonomy",
        label: "Pharmacy Taxonomy Codes",
        route: {
          type: "envKey",
          envKey: "pharmacyFrontendGenAI",
          envPath: "/pharmacy-taxonomy-codes",
        },
      },
      {
        id: "provider-prescriber",
        label: "Prescriber",
        abilityKey: "provider.prescriber",
        children: [
          {
            id: "provider-prescriber-search",
            label: "Prescriber Search",
            route: { type: "program", program: "RCPRF002" },
          },
          {
            id: "provider-prescriber-alt-address-qualifier",
            label: "Prescriber Alt Address Qualifier",
            route: { type: "program", program: "RCPAQ001" },
          },
        ],
      },
      {
        id: "provider-prescriber-network",
        label: "Prescriber Network",
        abilityKey: "provider.prescribernetwork",
        route: {
          type: "envKey",
          envKey: "prescriberNetworkFrontendGenAI",
          envPath: "/prescriber-network",
        },
      },
      {
        id: "provider-prescriber-product",
        label: "Prescriber Product",
        abilityKey: "provider.prescriber",
        children: [
          {
            id: "provider-prescriber-product-list",
            label: "Prescriber Product Lists",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-product-list",
            },
          },
          {
            id: "provider-prescriber-product-schedule",
            label: "Prescriber Product Schedules",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-product-schedule",
            },
          },
        ]
      },
      {
        id: "provider-prescriber-sanctions",
        label: "Prescriber Sanctions",
        abilityKey: "provider.prescriber",
        children: [
          {
            id: "provider-prescriber-sanction-code",
            label: "Prescriber Sanction Codes",
            route: { type: "program", program: "RCSCF002" },
          },
          {
            id: "provider-prescriber-sanction-source",
            label: "Prescriber Sanction Source",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-sanction-source",
            },
          },
          {
            id: "provider-prescriber-sanctions-master",
            label: "Prescriber Sanctions Master",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-sanctions-master",
            },
          },
        ]
      },
      {
        id: "provider-prescriber-specialty",
        label: "Prescriber Specialty",
        abilityKey: "provider.prescriber",
        children: [
          {
            id: "provider-prescriber-specialty-code",
            label: "Prescriber Speciality Codes",
            route: { type: "program", program: "RCDSF002" },
          },
          {
            id: "provider-prescriber-specialty-list",
            label: "Prescriber Specialty List",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-speciality-list",
            },
          },
        ],
      },
      {
        id: "provider-prescriber-taxonomy",
        label: "Prescriber Taxonomy",
        abilityKey: "provider.prescriber",
        children: [
          {
            id: "provider-prescriber-taxonomy-code",
            label: "Prescriber Taxonomy Codes",
            route: { type: "program", program: "RCHTC005" },
          },
          {
            id: "provider-prescriber-taxonomy-code-list",
            label: "Prescriber Taxonomy Code Lists",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-taxonomy-code-list",
            },
          },
          {
            id: "provider-prescriber-state-taxonomy-code",
            label: "Prescriber State Taxonomy Codes",
            route: {
              type: "envKey",
              envKey: "prescriberFrontendGenAI",
              envPath: "/prescriber-state-taxonomy-codes",
            },
          },
        ],
      },
    ],
  },

  // ─── PROFILE ─── //
  {
    id: "profile",
    label: "Profile",
    icon: "profile",
    abilityKey: "profile",
    children: [
      {
        id: "profile-prior-authorization",
        label: "Prior Authorization",
        children: [
          {
            id: "prior-authorization-profile",
            label: "Prior Authorization Profile",
            route: {
              type: "envKey",
              envKey: "profileFrontendGenAI",
              envPath: "/prior-authorization/prior-authorization-profile",
            },
          },
          {
            id: "prior-authorization-reason-code-profile",
            label: "Prior Authorization Reason Code Profile",
            route: {
              type: "envKey",
              envKey: "profileFrontendGenAI",
              envPath: "/prior-authorization/prior-authorization-reason-code-profile",
            },
          },
        ],
      },
    ],
  },

  // ─── LISTS ─── //
  {
    id: "lists",
    label: "Lists",
    icon: "lists",
    abilityKey: "batchprocess",
    children: [
      {
        id: "lists-gpi",
        label: "GPI Lists",
        abilityKey: "batchprocess.lists.gpilists",
        children: [
          {
            id: "lists-diagnosis-code-gpi",
            label: "Diagnosis Code GPI List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/diagnosis-code-gpi-list",
            },
          },
          {
            id: "lists-super-gpi",
            label: "Super GPI List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/super-gpi-list",
            },
          },
          {
            id: "lists-gpi-list",
            label: "GPI List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/gpi-list",
            },
          },
          {
            id: "lists-gpi-msc",
            label: "GPI MSC List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/gpi-msc-list",
            },
          },
        ],
      },
      {
        id: "lists-ndc",
        label: "NDC Lists",
        abilityKey: "batchprocess.lists.ndclists",
        children: [
          {
            id: "lists-ceiling-price-ndc",
            label: "Ceiling Price NDC List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/ceiling-price-ndc-list",
            },
          },
          {
            id: "lists-diagnosis-code-ndc",
            label: "Diagnosis Code NDC List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/diagnosis-code-ndc-list",
            },
          },
          {
            id: "lists-ndc-list",
            label: "NDC List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/ndc-list",
            },
          },
          {
            id: "lists-super-ndc",
            label: "Super NDC List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/super-ndc-list",
            },
          },
          {
            id: "lists-wildcard-ndc",
            label: "Wildcard NDC List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/wildcard-ndc-list",
            },
          },
        ],
      },
      {
        id: "lists-provider",
        label: "Provider Lists",
        abilityKey: "batchprocess.lists.providerlists",
        children: [
          {
            id: "lists-affiliation",
            label: "Affiliation List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/affiliation-list",
            },
          },
          {
            id: "lists-pharmacy-dispenser-type",
            label: "Pharmacy Dispenser Type List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/pharmacy-dispenser-type-list",
            },
          },
          {
            id: "lists-pharmacy",
            label: "Pharmacy List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/pharmacy-list",
            },
          },
          {
            id: "lists-pharmacy-network",
            label: "Pharmacy Network List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/pharmacy-network-list",
            },
          },
          {
            id: "lists-pharmacy-service-type",
            label: "Pharmacy Service Type List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/pharmacy-service-type-list",
            },
          },
          {
            id: "lists-pharmacy-taxonomy-code",
            label: "Pharmacy Taxonomy Code List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/pharmacy-taxonomy-code-list",
            },
          },
          {
            id: "lists-prescriber",
            label: "Prescriber List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/prescriber-list",
            },
          },
          {
            id: "lists-prescriber-sanction-source",
            label: "Prescriber Sanction Source List",
            route: {
              type: "envKey",
              envKey: "batchProcessFrontendGenAI",
              envPath: "/lists/prescriber-sanction-source-list",
            },
          },
        ],
      },
      {
        id: "lists-reject-code",
        label: "Reject Code List",
        abilityKey: "batchprocess.lists.providerlists.rejectcodelist",
        route: {
          type: "envKey",
          envKey: "batchProcessFrontendGenAI",
          envPath: "/lists/reject-code-list",
        },
      },
      {
        id: "lists-submit-window-override-list",
        label: "Submit Window Override List",
        abilityKey: "batchprocess.lists.providerlists.submissionoverridelist",
        route: {
          type: "envKey",
          envKey: "batchProcessFrontendGenAI",
          envPath: "/lists/submission-override-list",
        },
      },
    ],
  },

  // ─── MISCCELLANEOUS ─── //
  {
    id: "miscellaneous",
    label: "Miscellaneous",
    icon: "miscellaneous",
    abilityKey: "miscellaneous",
    children: [
       {
        id: "misc-surcharge-rule-table",
        label: "Surcharge Rule Table",
        abilityKey: "miscellaneous.tables.surchargeruletable",
        route: {
          type: "envKey",
          envKey: "miscFrontendGenAI",
          envPath: "/tables/surcharge-rule-table",
        },
      },
      {
        id: "misc-reversal-reason-code",
        label: "Reversal Reason Code",
        abilityKey: "miscellaneous.tables.reversalreasoncode",
        route: {
          type: "envKey",
          envKey: "miscFrontendGenAI",
          envPath: "/tables/reversal-reason-code",
        },
      }
    ],
  },

  // ─── RXCLAIM WEB ─── //
  {
    id: "presto",
    label: "RxClaim Web",
    icon: "presto",
    alwaysVisible: true,
    isExternal: true,
    route: { type: "external" },
  },
];
